import { useState, useRef, useCallback } from 'react'

function intersectionObserverEnabled() {
  return (
    'IntersectionObserver' in window &&
    'IntersectionObserverEntry' in window &&
    'intersectionRatio' in window.IntersectionObserverEntry.prototype
  )
}

const useScrolled = (initial = false) => {
  const [visible, setVisible] = useState(initial)

  const [observer] = useState(() => {
    if (intersectionObserverEnabled()) {
      return new IntersectionObserver((entries) => {
        console.log({ entries })
        setVisible(entries[0].isIntersecting)
      })
    }
    return null
  })

  const ref = useRef(null)

  const cbRef = useCallback(
    (node) => {
      if (!observer) {
        return
      }

      if (ref.current) {
        observer.unobserve(ref.current)
      }

      if (node) {
        observer.observe(node)
      }

      ref.current = node
    },
    [observer]
  )

  return [visible, cbRef]
}

export default useScrolled
